/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartIcon20Regular = forwardRef('TechPhoneSmartIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.75 14a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.999 5.251a3.25 3.25 0 0 1 3.25-3.25h5.5a3.25 3.25 0 0 1 3.25 3.25v9.5a3.25 3.25 0 0 1-3.25 3.25h-5.5a3.25 3.25 0 0 1-3.25-3.25v-9.5Zm3.25-1.75a1.75 1.75 0 0 0-1.75 1.75v9.5c0 .967.783 1.75 1.75 1.75h5.5a1.75 1.75 0 0 0 1.75-1.75v-9.5a1.75 1.75 0 0 0-1.75-1.75h-5.5Z" })));
});
